import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useApi, useOrg } from '../api/app-context';
import { errorLine } from '../api/errors';
import { LOADING } from '../lib/copy';
import './demo.css';
export interface DemoManifestView {
  name: string;
  routes: {
    label: string;
    path: string;
  }[];
  version: string;
}
export function DemoDocument() {
  const { evidenceId = '' } = useParams();
  const api = useApi(),
    org = useOrg();
  const data = useQuery({
    queryKey: ['demo-evidence', org.id, evidenceId],
    queryFn: () => api.demoEvidence(evidenceId),
  });
  return (
    <div className="column demo-source">
      <h1 className="title">Source document</h1>
      <p className="lede">
        Fictional source material created for this demo. This is the full stored text supporting the
        cited passage, not a live webpage.
      </p>
      {data.data ? (
        <>
          <p className="src">Captured {new Date(data.data.captured_at).toLocaleString()}</p>
          <pre className="demo-document">{data.data.text}</pre>
          <details className="evidence-details">
            <summary>Document integrity</summary>
            <div className="evidence-details-body">SHA-256: {data.data.sha256}</div>
          </details>
        </>
      ) : (
        <p>{data.error ? errorLine(data.error) : LOADING}</p>
      )}
    </div>
  );
}
